import React from 'react'
import CustomTabs from '../../components/DefaultTabs/CustomTabs'
import { BrandCombinationIcon, SourceIcon, SubSourceIcon } from "../../utils/svgIcons";

function index() {
  const tabs = [
    {
      key: "BrandCombination",
      title: "Brand Combination",
      icon: <BrandCombinationIcon />,
      columnType: "BrandCombination"
    },
    {
      key: "SourceCombination",
      title: "Source",
      icon: <SourceIcon />,
      columnType: "Source"
    },
    {
      key: "SubSourceCombination",
      title: "Sub Source",
      icon: <SubSourceIcon />,
      columnType: "SubSource"
    },
  ];
  return (
      <CustomTabs default={"BrandCombination"} tabs={tabs} />
  )
}

export default index;